import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Icons,
  Button,
} from '../';

import NavBar from '../NavBar';

// Todo: we should move this component to composition and remove props base

interface HeaderProps {
  children?: ReactNode;
  menuOptions: Array<{
    title: string;
    icon?: string;
    onClick: () => void;
  }>;
  isReturnEnabled?: boolean;
  onClickReturnButton?: () => void;
  isSticky?: boolean;
  WhiteLabeling?: {
    createLogoComponentFn?: (React: any, props: any) => ReactNode;
  };
  PatientInfo?: ReactNode;
  Secondary?: ReactNode;
}

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  PatientInfo,
  Secondary,
  ...props
}: HeaderProps): ReactNode {
  const { t } = useTranslation('Header');

  const onClickReturn = () => {
    return;
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <>
      <div className="bg-primary-dark flex w-full items-center justify-between px-3 py-1.5 md:px-4 md:py-2">
        <div className="ml-1 md:ml-4">
          <Icons.logoRP className="h-9 w-auto [filter:brightness(0)_saturate(100%)_invert(68%)_sepia(30%)_saturate(418%)_hue-rotate(146deg)_brightness(92%)_contrast(90%)] md:h-12" />
        </div>

        {/* PatientInfo y menú desplegable alineados a la derecha */}
        <div className="flex items-center">
          {PatientInfo && (
            <div className="mr-1 max-w-[180px] overflow-hidden md:mr-4 md:max-w-none">
              <div className="origin-right scale-[0.45] md:scale-100">{PatientInfo}</div>
            </div>
          )}

          {menuOptions.length === 1 ? (
            <Button
              variant="ghost"
              size="icon"
              className="h-8 w-8 p-0.5 md:h-10 md:w-10 md:p-1"
              aria-label={menuOptions[0].title}
              title={menuOptions[0].title}
              onClick={menuOptions[0].onClick}
            >
              <Icons.GearSettings className="h-7 w-7 text-[#69AFC1] md:h-9 md:w-9" />
            </Button>
          ) : (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 p-0.5 md:h-10 md:w-10 md:p-1"
                >
                  <Icons.GearSettings className="h-7 w-7 text-[#69AFC1] md:h-9 md:w-9" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {menuOptions.map((option, index) => {
                  const IconComponent = option.icon
                    ? Icons[option.icon as keyof typeof Icons]
                    : null;
                  return (
                    <DropdownMenuItem
                      key={index}
                      onSelect={option.onClick}
                      className="flex items-center gap-2 py-2"
                    >
                      {IconComponent && (
                        <span className="flex h-4 w-4 items-center justify-center">
                          <Icons.ByName name={IconComponent.name} />
                        </span>
                      )}
                      <span className="flex-1">{option.title}</span>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </div>

      <NavBar
        isSticky={isSticky}
        className="scrollbar-thin scrollbar-thumb-primary/20 scrollbar-track-transparent overflow-x-auto overflow-y-hidden"
        {...props}
      >
        <div className="relative h-[70px] min-w-[1200px] items-center">
          <div className="absolute top-1/2 left-[200px] h-10 -translate-y-1/2">{Secondary}</div>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
            <div className="flex scale-[1.2] items-center justify-center space-x-4">{children}</div>
          </div>
        </div>
      </NavBar>
    </>
  );
}

export default Header;
